'use client';

import Link from 'next/link';

interface ErrorProp extends Error {
  digest?: string;
}

export function GeneralError({ error, reset }: { error: ErrorProp; reset: () => void }) {
  return (
    <div className="card m-auto w-fit max-w-5xl">
      <div className="card-body">
        <h2 className="card-title">Something went wrong!</h2>
        {!!error.message && <p>{error.message}</p>}
        <div className="flex items-center gap-3">
          <Link href="/" className="btn">
            Go back home
          </Link>
        </div>
      </div>
    </div>
  );
}
